// Pestañas de la seccion Equipo: las cuentas y los perfiles de acceso son dos
// pantallas de la misma seccion — una dice quien entra, la otra que ve.

import { NavLink } from 'react-router-dom';

const tabCls = ({ isActive }: { isActive: boolean }): string =>
  `min-h-[2.75rem] px-4 flex items-center text-sm border-b-2 -mb-px transition ${
    isActive
      ? 'border-brand text-brand font-medium'
      : 'border-transparent text-ink-muted hover:text-ink dark:hover:text-ink-inverted'
  }`;

export default function TeamTabs(): JSX.Element {
  return (
    <nav
      data-help="team.tabs"
      aria-label="Secciones del equipo"
      className="flex gap-1 border-b border-surface-border dark:border-surface-dark-border"
    >
      <NavLink to="/team" end className={tabCls}>
        Cuentas
      </NavLink>
      <NavLink to="/team/profiles" className={tabCls}>
        Perfiles de acceso
      </NavLink>
    </nav>
  );
}
